/* ANSOBABY — shared AJAX add-to-cart, feedback (button state, fly-to-bag,
   bag bump, toast) and header badge refresh.
   Used by product cards (home / collection / related / search) and the product page. */
(function () {
  var T = window.ANSOBABY_T || {};
  var toastTimer;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Toast: plain message, or (opts.title) a card with thumbnail + "view cart" link */
  function toast(msg, opts) {
    if (!msg) return;
    opts = opts || {};
    var el = document.getElementById('ab-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ab-toast';
      el.className = 'ab-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    if (opts.title) {
      el.classList.add('ab-toast--rich');
      el.innerHTML =
        (opts.image ? '<span class="ab-toast__thumb"><img src="' + esc(opts.image) + '" alt=""></span>' : '') +
        '<span class="ab-toast__text"><strong>' + esc(msg) + '</strong><span>' + esc(opts.title) + '</span></span>' +
        '<a class="ab-toast__link" href="' + esc(T.cartUrl || '/cart') + '">' + esc(T.cart || 'Cart') + ' →</a>';
    } else {
      el.classList.remove('ab-toast--rich');
      el.textContent = msg;
    }
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, opts.title ? 3200 : 2200);
  }

  function refreshBadge() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        document.querySelectorAll('[data-ab-cart]').forEach(function (link) {
          var badge = link.querySelector('[data-ab-cart-badge]');
          if (count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'ab-hdr__badge';
              badge.setAttribute('data-ab-cart-badge', '');
              link.appendChild(badge);
            }
            badge.textContent = count;
          } else if (badge) {
            badge.remove();
          }
        });
        document.dispatchEvent(new CustomEvent('ab:cart:updated', { detail: cart }));
        return cart;
      });
  }

  /* The product image that belongs to a clicked button (card image, or the current PDP slide) */
  function sourceImage(btn) {
    var card = btn.closest('.ab-prod');
    if (card) return card.querySelector('.ab-prod__media img');
    var pdp = btn.closest('[data-ab-pdp]');
    if (pdp) {
      var track = pdp.querySelector('[data-ab-track]');
      var slides = pdp.querySelectorAll('.ab-pdp__slide img');
      if (track && slides.length) {
        var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        return slides[Math.max(0, Math.min(slides.length - 1, i))];
      }
    }
    return null;
  }

  function visibleCartIcon() {
    var links = document.querySelectorAll('[data-ab-cart]');
    for (var i = 0; i < links.length; i++) {
      var r = links[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return links[i];
    }
    return null;
  }

  /* A copy of the product image flies in an arc into the bag icon */
  function flyToCart(img, cartLink) {
    if (reduceMotion || !img || !cartLink || !img.animate) return Promise.resolve();
    var from = img.getBoundingClientRect();
    var to = cartLink.getBoundingClientRect();
    if (!from.width || from.bottom < 0 || from.top > window.innerHeight) return Promise.resolve();
    var size = Math.min(from.width, from.height, 180);
    var startX = from.left + from.width / 2 - size / 2;
    var startY = from.top + from.height / 2 - size / 2;
    var dx = to.left + to.width / 2 - (startX + size / 2);
    var dy = to.top + to.height / 2 - (startY + size / 2);
    var ghost = img.cloneNode();
    ghost.removeAttribute('srcset');
    ghost.removeAttribute('sizes');
    ghost.src = img.currentSrc || img.src;
    ghost.className = 'ab-fly';
    ghost.style.cssText = 'left:' + startX + 'px;top:' + startY + 'px;width:' + size + 'px;height:' + size + 'px;';
    document.body.appendChild(ghost);
    var anim = ghost.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.45 - 90) + 'px) scale(.55)', opacity: 1, offset: 0.45 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(.12)', opacity: 0.35 }
    ], { duration: 750, easing: 'cubic-bezier(.45, .05, .55, .95)' });
    return anim.finished.catch(function () {}).then(function () { ghost.remove(); });
  }

  function bump(cartLink) {
    if (!cartLink) return;
    cartLink.classList.remove('is-bump');
    void cartLink.offsetWidth;
    cartLink.classList.add('is-bump');
    setTimeout(function () { cartLink.classList.remove('is-bump'); }, 700);
  }

  /* Button: spinner while adding, then a short green "✓ Added" confirmation */
  function buttonState(btn, state) {
    if (!btn) return;
    if (state === 'busy') {
      if (!btn.hasAttribute('data-label')) btn.setAttribute('data-label', btn.innerHTML);
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-busy');
      return;
    }
    btn.removeAttribute('aria-busy');
    btn.classList.remove('is-busy');
    if (state === 'done') {
      btn.classList.add('is-added');
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>' + esc(T.addedShort || 'Added');
      clearTimeout(btn._abReset);
      btn._abReset = setTimeout(function () {
        btn.classList.remove('is-added');
        if (btn.hasAttribute('data-label')) btn.innerHTML = btn.getAttribute('data-label');
      }, 1800);
    }
  }

  function add(variantId, quantity, addedLabel, btn) {
    if (!variantId) return;
    var img = btn ? sourceImage(btn) : null;
    var title = btn ? btn.getAttribute('data-title') : '';
    buttonState(btn, 'busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        buttonState(btn, 'done');
        var cartLink = visibleCartIcon();
        var flight = flyToCart(img, cartLink);
        return Promise.all([refreshBadge(), flight]).then(function () {
          bump(cartLink);
          if (title) toast(T.added || addedLabel, { title: title, image: img && (img.currentSrc || img.src) });
          else toast(addedLabel);
        });
      })
      .catch(function (err) {
        buttonState(btn, 'idle');
        toast((err && err.description) || 'Sorry, could not add to cart');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ab-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-busy')) return;
    add(btn.getAttribute('data-variant-id'), Number(btn.getAttribute('data-quantity')) || 1, btn.getAttribute('data-added'), btn);
  });

  window.ANSOBABY = window.ANSOBABY || {};
  window.ANSOBABY.cart = { add: add, toast: toast, refreshBadge: refreshBadge };
})();
